import { useFormStore } from '@/stores/form'
import { useAuthStore } from '@/stores/auth'
import apiHelperService from '@/services'
import { notify } from 'notiwind'
import i18n from '@/i18n/i18n'

const doNotify = (title, text, duration = 6000, group = 'error') => {
  notify(
    {
      group: group,
      title,
      text
    },
    duration
  )
}

const checkEligibility = ({ options } = actionParams) => {
  const formStore = useFormStore()

  formStore.extraMap.totalRefundableAmount = 0

  for (let i = 0; i < options.length; i++) {
    formStore.extraMap.totalRefundableAmount += options[i].totalRefundableAmount
  }

  formStore.extraMap.showRefundTable = !!formStore.form.values.useFileNumber

  return options
}

const searchRefundWhiteList = async () => {
  const authStore = useAuthStore()
  const formStore = useFormStore()

  const { referenceRequestNumber } = formStore.form.values
  if (!referenceRequestNumber) {
    return
  }
  if (!formStore.extraMap.othersBeneficiaryType) {
    return
  }
  const res = await apiHelperService.post('/api/refundRequest/searchRefundWhitelist', {
    requestNumber: referenceRequestNumber
  })
  if (res && res?.collection?.length > 0) {
    formStore.extraMap.refundWhiteListCollection = res.collection
    const { beneficiaryUnifiedNumber } = formStore.extraMap.refundWhiteListCollection?.[0]
    const user = authStore.user
    if (!authStore.isUserTypingCenter && beneficiaryUnifiedNumber == user.unifiedNumber) {
      return
    } else {
      if (authStore.isUserTypingCenter && formStore.form.values.sponsorUnifiedNumber) {
        formStore.form.setFieldValue('referenceRequestNumber', null)
        doNotify(i18n.global.t('unifiedNumberNotFound'), i18n.global.t('unifiedNumberNotFound'))
        return
      } else {
        doNotify(i18n.global.t('stopRefundRequest'), i18n.global.t('stopRefundRequest'))
        return
      }
    }
  } else {
    doNotify(i18n.global.t('stopRefundRequest'), i18n.global.t('stopRefundRequest'))
    return
  }
}

export default function (actionName, actionParams) {
  switch (actionName) {
    case 'searchRefundWhiteList':
      searchRefundWhiteList(actionParams)
      break
    case 'checkEligibility':
      return checkEligibility(actionParams)
    default:
      break
  }
}
